import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { fetchDispath } from '../../functions/fetch'
import { gost } from './types'
import { getProjectJournalById, postProjectJournalRow } from '../../api/journals'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import PageList from '../../components/PageListAPI'
import validateProps from '../../functions/validateProps'
import { enqueueSnackbar } from '../../reducers/notifier'
import SimpleAdd from '../../components/SimpleAdd'
import * as actions from '../../reducers/form';
import Button from '@mui/material/Button';

const formName = 'JournalCablesAddRows'

export default function JournalCablesAddRows() {
  const params = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const [gostCode, setGostCode] = useState(null)
  const [columns, setColumns] = useState([])
  useEffect(() => {
    dispatch(fetchDispath({
      param: {
        idProject: params.idProject,
        id: params.idDoc,
      },
      progress: true,
      request: getProjectJournalById,
    })).then(res => {
      setGostCode(res.get.gostCode)
    }).catch(err => console.log(err))
  }, [dispatch, params])
  useEffect(() => {
    const obj = gost[gostCode]
    if (!obj) return;
    const arr = [{
      field: 'rowNumber', label: 'Номер', type: 'text' , textProps: { type: 'number' },
      validator: [value => value !== ''], errorText: 'Поле обязательно',
    },]
    let errorValidate = {
      rowNumber: false
    }
    let init = {
      rowNumber: '',
    }
    Object.keys(obj).forEach(key => {
      arr.push({
        field: key, label: obj[key].label, type: 'text', textProps: { type: obj[key].type },
        validator: [value => value !== ''], errorText: 'Поле обязательно',
      })
      errorValidate[key] = false
      init[key] = obj[key].type === 'text' ? '' : 0
    })
    setColumns(arr)
    dispatch(actions.formInitialize({
      ...init, errorValidate
    }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch, gostCode])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form
  const handleSave = (e) => {
    e.preventDefault();
    const isError = validateProps(columns, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    const { rowNumber, errorValidate, ...dataFromType } = values
    dispatch(actions.formSubmitAPI({
      props: {
        rowNumber: rowNumber,
        extraData: {},
        dataFromType: dataFromType
      },
      url: postProjectJournalRow.path({ idProject: params.idProject, id: params.idDoc }),
      method: postProjectJournalRow.type,
      history: history
    }, formName))
  };

  return <div className='App-paper'>
    <form autoComplete="off" onSubmit={handleSave}>
      <div style={{ padding: '16px' }}>
        <SimpleAdd formName={formName} arr={columns} title='Добавить строку в кабельный журнал' />
      </div>
      <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
      <Button type="submit" color="primary">Сохранить</Button>
    </form>
  </div>
}